(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-banner-order"]) return;
  try {
    
function updateIPNativeFinishing(form, initialize){
 const record=form.querySelector('[data-finishing-variants]');if(!record)return;
 const variants=JSON.parse(record.textContent);
 const selector=form.querySelector('[data-base-variant]');
 const hidden=form.querySelector('[data-finishing-variant]');
 const names=['None','Pole pockets','Reinforced corners','Pole pockets + reinforced corners','Wind slits','Pole pockets + wind slits','Reinforced corners + wind slits','Pole pockets + reinforced corners + wind slits'];
 if(initialize){const current=variants.find(v=>String(v.id)===hidden.value);if(current){const base=variants.find(v=>v.option1===current.option1&&v.option2==='None');if(base)selector.value=String(base.id);const mask=names.indexOf(current.option2);form.querySelectorAll('[data-extra-bit]').forEach(el=>el.value=mask>0&&(mask&Number(el.dataset.extraBit))?'Yes':'No');}}
 const base=variants.find(v=>String(v.id)===selector.value);let mask=0;form.querySelectorAll('[data-extra-bit]').forEach(el=>{if(el.value==='Yes')mask|=Number(el.dataset.extraBit);});
 const selected=base&&variants.find(v=>v.option1===base.option1&&v.option2===names[mask]);
 const quantity=Number(form.querySelector('[name="quantity"]').value);
 hidden.value=selected?String(selected.id):'';
 form.querySelector('[type="submit"]').disabled=!selected||!selected.available;
 const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
 form.querySelector('[data-native-unit]').textContent=selected?money(selected.price):'—';
 form.querySelector('[data-native-total]').textContent=selected&&Number.isInteger(quantity)&&quantity>0?money(selected.price*quantity):'—';
}
function updateIPFinishing(form){
 updateIPNativeFinishing(form,false);
 if(!form.querySelector('[data-size-calculator]'))return;
 const read=key=>Number(form.querySelector('[data-dimension="'+key+'"]').value);
 const wf=read('width_ft'),wi=read('width_in'),hf=read('height_ft'),hi=read('height_in');
 const width=wf*12+wi,height=hf*12+hi,quantity=Number(form.querySelector('[name="quantity"]').value);
 const fields=Array.from(form.querySelectorAll('[data-dimension]'));
 const valid=fields.every(e=>e.value!==''&&e.validity.valid)&&width>0&&height>0&&Number.isInteger(quantity)&&quantity>0;
 const summary=form.querySelector('.ip-price-summary');
 const error=form.querySelector('.ip-dimension-error');error.hidden=valid;
 form.querySelector('[type="submit"]').disabled=true;
 if(!valid){summary.querySelectorAll('strong').forEach(e=>e.textContent='—');return;}
 const area=width*height/144,base=Math.max(9999,Math.round(width*height*275/144));
 let extras=0;form.querySelectorAll('[data-extra-cents]').forEach(s=>{if(s.value==='Yes')extras+=Number(s.dataset.extraCents);});
 const unit=base+extras,multiSavings=Math.max(0,quantity-1)*1000,subtotal=unit*quantity-multiSavings;
 const shipping=Number(form.querySelector('[data-shipping-estimate]').selectedOptions[0].dataset.cents);
 const shippingKnown=quantity===1&&width<=120&&height<=120;
 const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
 summary.querySelector('[data-base-total]').textContent=money(base);
 summary.querySelector('[data-extra-total]').textContent=money(extras);
 summary.querySelector('[data-unit-total]').textContent=money(unit);
 summary.querySelector('[data-multi-savings]').textContent='−'+money(multiSavings);
 summary.querySelector('[data-order-total]').textContent=money(subtotal);
 summary.querySelector('[data-shipping-total]').textContent=shippingKnown?money(shipping):summary.dataset.shippingQuote;
 summary.querySelector('[data-estimated-total]').textContent=shippingKnown?money(subtotal+shipping):summary.dataset.shippingQuote;
}
document.addEventListener('change',event=>{const form=event.target.closest('.ip-banner-form');if(form)updateIPFinishing(form);});
document.addEventListener('input',event=>{if(event.target.name==='quantity'||event.target.matches('[data-dimension]')){const form=event.target.closest('.ip-banner-form');if(form)updateIPFinishing(form);}});
document.addEventListener('submit',event=>{const form=event.target;if(!form.matches('.ip-banner-form')||!form.querySelector('[data-priced-finishing]'))return;updateIPFinishing(form);if(form.querySelector('[type="submit"]').disabled){event.preventDefault();}});
document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.ip-banner-form').forEach(form=>{updateIPNativeFinishing(form,true);if(form.querySelector('[data-size-calculator]'))updateIPFinishing(form);}));

document.addEventListener('change',function(event){const input=event.target;if(input.matches('.ip-banner-form input[type="file"]')){const review=input.form.querySelector('.ip-artwork-check input');if(review)review.checked=false;const file=input.files[0];input.setCustomValidity(file&&!/\.pdf$/i.test(file.name)?input.dataset.pdfError||input.closest('ip-print-artwork').dataset.invalid:'');if(!input.checkValidity()){input.reportValidity();}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-tent-config"]) return;
  try {
    
function setupTentConfigurations(){document.querySelectorAll('.ip-tent-config').forEach(section=>{if(section.dataset.ready)return;const map=window.ipTentConfigurations?.[section.dataset.size],form=section.querySelector('form'),id=form.querySelector('[data-configuration-id]'),price=section.querySelector('[data-config-price]'),button=section.querySelector('[data-config-add]');if(!map)return;section.dataset.ready='true';section.querySelector('[data-config-error]').hidden=true;const value=p=>{const e=form.querySelector('[data-part="'+p+'"]');return e?.type==='radio'?form.querySelector('[data-part="'+p+'"]:checked').value:e?.value||'0';};function update(){const parts=['hw','bag','mesh','sand','full','long','half'];form.querySelectorAll('select[data-part]').forEach(select=>{const part=select.dataset.part;if(!parts.includes(part))return;const current=select.value;Array.from(select.options).sort((a,b)=>{const cost=v=>{const key=parts.map(p=>p===part?v:value(p)).join('-');return map[key]?.[1]??Infinity;};return cost(a.value)-cost(b.value);}).forEach(option=>select.appendChild(option));select.value=current;});const hw=value('hw');form.querySelector('[data-bag-row]').hidden=hw==='0';if(hw==='0')form.querySelector('[data-part="bag"]').value='0';const key=['hw','bag','mesh','sand','full','long','half'].map(value).join('-'),variant=map[key];if(!variant){button.disabled=true;return;}id.value=variant[0];const quantity=Number(form.querySelector('[data-quantity]').value)||1;price.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(variant[1]*quantity/100);button.disabled=false;}const requested=new URL(location.href).searchParams.get('variant'),entry=Object.entries(map).find(([,v])=>v[0]===requested);if(entry){entry[0].split('-').forEach((v,i)=>{const part=['hw','bag','mesh','sand','full','long','half'][i];const e=form.querySelector('[data-part="'+part+'"]');if(e?.type==='radio')form.querySelector('[data-part="hw"][value="'+v+'"]').checked=true;else if(e)e.value=v;});}form.addEventListener('change',update);form.addEventListener('input',update);form.addEventListener('submit',()=>{form.querySelectorAll('select[data-part]').forEach(e=>{const hidden=document.createElement('input');hidden.type='hidden';hidden.name=e.name;hidden.value=e.selectedOptions[0].textContent;form.appendChild(hidden);e.removeAttribute('name');});const packageInput=document.createElement('input');packageInput.type='hidden';packageInput.name='properties[Package]';packageInput.value=form.querySelector('[data-part="hw"]:checked+span').textContent;form.querySelectorAll('[data-part="hw"]').forEach(e=>e.removeAttribute('name'));form.appendChild(packageInput);});update();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupTentConfigurations);else setupTentConfigurations();document.addEventListener('shopify:section:load',setupTentConfigurations);document.addEventListener('ip:tent-data',setupTentConfigurations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ip-tent-order"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-tent-variant]'))return;const section=event.target.closest('.ip-tent-order');section.querySelector('[data-tent-price]').textContent=event.target.selectedOptions[0].dataset.price;const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();
})();
